export const getTranslations = async (lang) => {
    const response = await fetch('/assets/jsons/translate.json');
    const translations = await response.json();
    return translations[lang];
};
  
export const setLanguage = (lang) => {
    localStorage.setItem('language', lang);
    window.location.reload();
};
  
export const getLanguage = () => {
    return localStorage.getItem('language') || 'pt';
};
  